export default {
   
    dependencia: {
    }
}